import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Scope } from './scope.interface';
import scopeService from './scope.service';

export interface ScopeState {
   scopes: Array<Scope>;
}

const ScopeStore: Module<ScopeState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(context, { resource_type_key, requires_resource_id }: { resource_type_key: string; requires_resource_id: number }) {
         await scopeService.get(resource_type_key, requires_resource_id);
      },
   },
};

export default ScopeStore;
